export default "__VITE_ASSET__DjwRtjLC__"